export const EMPTY_UI = "-";
